import AppRouter from "./router";
import { ensureHub } from "@hub";
import { StoreProvider } from "./js/state/store";
import { SellerProvider } from "./js/state/sellerState";
import { MessagingLiveProvider } from "./js/hooks/useNotifications";
import "./styles/theme.css";
import "./styles/global.css";
import "./styles/layout.css";
import "./styles/forms.css";
import "./styles/mobile.css";
import "./styles/components.css";
import "./styles/modals.css";
import "./styles/guest-lock.css";
import "./styles/seller.css";
import "./styles/messaging.css";
import "./styles/refinements.css";
import "./styles/polish.css";
import "./styles/onboarding.css";
import "./styles/sandbox-billing.css";
import "./styles/broker-desk.css";
import "./styles/fullwidth.css";
import "./styles/cinematic-zoom.css";
import "./styles/journey-workspace.css";
import "./styles/desk-workspace.css";
import "./styles/file-packet.css";
import "./styles/admin-hub.css";
import "./styles/beta-onboard.css";
import "./styles/the-hub.css";
import "./styles/prospects.css";
import "./styles/founders-view.css";
import "./styles/accounts.css";
import "./styles/restore.css";
import "./styles/backup.css";
import "./styles/legal.css";
import "@tour/sales-tour.css";
import { ensureFounderHub, ensureTheHub } from "./js/theHub";
import { ensureProspects } from "./js/prospects";
import { ensureAccounts, startRestoreCapture } from "./js/accounts";
import { tickSuspensionTimers } from "./js/api/accountLifecycle";
import { ensureClientCodes } from "./js/api/clientAccess";
import "./styles/account-portal.css";
import "./styles/containers.css";

ensureHub();
ensureTheHub();
ensureFounderHub();
ensureProspects();
ensureAccounts();
ensureClientCodes();
tickSuspensionTimers();
startRestoreCapture();

export default function App() {
  return (
    <StoreProvider>
      <SellerProvider>
        <MessagingLiveProvider>
          <AppRouter />
        </MessagingLiveProvider>
      </SellerProvider>
    </StoreProvider>
  );
}
